import { createAction } from 'redux-actions';

export const setCurrentListing = createAction('SET_CURRENT_LISTING', listing => ({ listing }));
export const setQuery = createAction('SET_LISTING_QUERY', query => ({ query }));
export const paginate = createAction('PAGINATE_LISTING', activePage => ({ activePage }));
export const setActivePage = createAction('SET_LISTING_ACTIVE_PAGE', activePage => ({ activePage }));
export const setView = createAction('SET_LISTING_VIEW', view => ({ view }));

export const getListings = createAction('GET_LISTINGS', query => ({ query }));
export const getListingsSuccess = createAction('GET_LISTINGS_SUCCESS', (listings, count) => ({ listings, count }));
export const getListingsFail = createAction('GET_LISTINGS_FAIL', error => ({ error }));

export const getListingById = createAction('GET_LISTING_BY_ID', id => ({ id }));
export const getListingByIdSuccess = createAction('GET_LISTING_BY_ID_SUCCESS', listing => ({ listing }));
export const getListingByIdFail = createAction('GET_LISTING_BY_ID_FAIL', error => ({ error }));

export const addListing = createAction('ADD_LISTING', listing => ({ listing }));
export const addListingSuccess = createAction('ADD_LISTING_SUCCESS', listing => ({ listing }));
export const addListingFail = createAction('ADD_LISTING_FAIL', error => ({ error }));

export const updateListing = createAction('UPDATE_LISTING', listing => ({ listing }));
export const updateListingSuccess = createAction('UPDATE_LISTING_SUCCESS', listing => ({ listing }));
export const updateListingFail = createAction('UPDATE_LISTING_FAIL', error => ({ error }));

export const searchListings = createAction('SEARCH_LISTINGS', query => ({ query }));
export const searchListingsSuccess = createAction('SEARCH_LISTINGS_SUCCESS', listings => ({ listings }));
export const searchListingsFail = createAction('SEARCH_LISTINGS_FAIL');
